/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: c3d9d0a0 (Wed Sep 23 18:58:40 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
import {
  CommunityInviteItem,
  CommunityInviteItemFromJSON,
  CommunityInviteItemToJSON,
  PaginationResponse,
  PaginationResponseFromJSON,
  PaginationResponseToJSON,
} from './'

/**
 *
 * @export
 * @interface FetchCommunityInvitesResponse
 */
export interface FetchCommunityInvitesResponse {
  /**
   *
   * @type {Array<CommunityInviteItem>}
   * @memberof FetchCommunityInvitesResponse
   */
  communityInvites: Array<CommunityInviteItem>
  /**
   *
   * @type PaginationResponse
   * @memberof FetchCommunityInvitesResponse
   */
  pagination?: PaginationResponse
}

export function FetchCommunityInvitesResponseFromJSON(
  json: any
): FetchCommunityInvitesResponse {
  return FetchCommunityInvitesResponseFromJSONTyped(json, false)
}

export function FetchCommunityInvitesResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FetchCommunityInvitesResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    communityInvites: (json['communityInvites'] as Array<any>).map(
      CommunityInviteItemFromJSON
    ),
    pagination: !exists(json, 'pagination')
      ? undefined
      : PaginationResponseFromJSON(json['pagination']),
  }
}

export function FetchCommunityInvitesResponseToJSON(
  value?: FetchCommunityInvitesResponse | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    communityInvites: (value.communityInvites as Array<any>).map(
      CommunityInviteItemToJSON
    ),
    pagination: PaginationResponseToJSON(value.pagination),
  }
}
